// @flow

import _ from 'lodash';

import $ from 'rgs-jquery';
import Velocity from 'rgs-velocity-animate';


export const scrollTo = (selector: string | Node) => {
	const element = _.isString(selector) ? $(selector) : selector;

	_.delay(() => {
		Velocity(element, 'scroll');
	}, 200);
};

